import { AbstractControl } from '@angular/forms';

export function TranslatedMaxLength(
  maxLength: number,
  translatedByMachineHeader: string,
) {
  return (control: AbstractControl) => {
    if (control.value) {
      const maxLengthWithMachineHeader = control.value.startsWith(
        translatedByMachineHeader,
      )
        ? maxLength + translatedByMachineHeader.length
        : maxLength;
      if (control.value.length > maxLengthWithMachineHeader) {
        return { TranslatedMaxLength: true };
      }
    }
  };
}
